export default __webpack_public_path__ + "static/media/checkbox-selected.4c47e564.svg";